import type { FC } from "react";

import { CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

import type { CardsElementProps } from "../types";

export const CustomCardBody: FC<CardsElementProps> = ({
  children,
  classes,
}) => {
  return (
    <CardContent className={cn("px-8 pb-8", classes)}>{children}</CardContent>
  );
};
